import React from "react";

/**控制显示隐藏的模板 */
export default (props) => {
  return props.show ? <React.Fragment>{props.children}</React.Fragment> : null;
};